"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Account = _interopRequireDefault(require("./react-icons/product/Account"));

var _Blank = _interopRequireDefault(require("./react-icons/product/Blank"));

var _Blog = _interopRequireDefault(require("./react-icons/product/Blog"));

var _Book = _interopRequireDefault(require("./react-icons/product/Book"));

var _Certificate = _interopRequireDefault(require("./react-icons/product/Certificate"));

var _Checkmarkmulticolor = _interopRequireDefault(require("./react-icons/product/Checkmarkmulticolor"));

var _Checkmark = _interopRequireDefault(require("./react-icons/product/Checkmark"));

var _Clipboard = _interopRequireDefault(require("./react-icons/product/Clipboard"));

var _Clocksmall = _interopRequireDefault(require("./react-icons/product/Clocksmall"));

var _Design = _interopRequireDefault(require("./react-icons/product/Design"));

var _Digitaldownload = _interopRequireDefault(require("./react-icons/product/Digitaldownload"));

var _Featureafterpurchase = _interopRequireDefault(require("./react-icons/product/Featureafterpurchase"));

var _Flagship = _interopRequireDefault(require("./react-icons/product/Flagship"));

var _Gift = _interopRequireDefault(require("./react-icons/product/Gift"));

var _Handshake = _interopRequireDefault(require("./react-icons/product/Handshake"));

var _Help = _interopRequireDefault(require("./react-icons/product/Help"));

var _Logout = _interopRequireDefault(require("./react-icons/product/Logout"));

var _Manage = _interopRequireDefault(require("./react-icons/product/Manage"));

var _Marketsell = _interopRequireDefault(require("./react-icons/product/Marketsell"));

var _Microphone = _interopRequireDefault(require("./react-icons/product/Microphone"));

var _Minicourse = _interopRequireDefault(require("./react-icons/product/Minicourse"));

var _Page = _interopRequireDefault(require("./react-icons/product/Page"));

var _Play = _interopRequireDefault(require("./react-icons/product/Play"));

var _Presell = _interopRequireDefault(require("./react-icons/product/Presell"));

var _Preview = _interopRequireDefault(require("./react-icons/product/Preview"));

var _Resourcelibrary = _interopRequireDefault(require("./react-icons/product/Resourcelibrary"));

var _Searchinitial = _interopRequireDefault(require("./react-icons/product/Searchinitial"));

var _Searchnoresult = _interopRequireDefault(require("./react-icons/product/Searchnoresult"));

var _Settings = _interopRequireDefault(require("./react-icons/product/Settings"));

var _Students = _interopRequireDefault(require("./react-icons/product/Students"));

var _Updates = _interopRequireDefault(require("./react-icons/product/Updates"));

var _Upgrade = _interopRequireDefault(require("./react-icons/product/Upgrade"));

var _Webinarreplay = _interopRequireDefault(require("./react-icons/product/Webinarreplay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable eol-last */

/* eslint-disable quote-props */
var icons = {
  'product-account': _Account["default"],
  'product-blank': _Blank["default"],
  'product-blog': _Blog["default"],
  'product-book': _Book["default"],
  'product-certificate': _Certificate["default"],
  'product-checkmark-multicolor': _Checkmarkmulticolor["default"],
  'product-checkmark': _Checkmark["default"],
  'product-clipboard': _Clipboard["default"],
  'product-clock-small': _Clocksmall["default"],
  'product-design': _Design["default"],
  'product-digital-download': _Digitaldownload["default"],
  'product-feature-afterpurchase': _Featureafterpurchase["default"],
  'product-flagship': _Flagship["default"],
  'product-gift': _Gift["default"],
  'product-handshake': _Handshake["default"],
  'product-help': _Help["default"],
  'product-logout': _Logout["default"],
  'product-manage': _Manage["default"],
  'product-market-sell': _Marketsell["default"],
  'product-microphone': _Microphone["default"],
  'product-mini-course': _Minicourse["default"],
  'product-page': _Page["default"],
  'product-play': _Play["default"],
  'product-pre-sell': _Presell["default"],
  'product-preview': _Preview["default"],
  'product-resource-library': _Resourcelibrary["default"],
  'product-search-initial': _Searchinitial["default"],
  'product-search-no-result': _Searchnoresult["default"],
  'product-settings': _Settings["default"],
  'product-students': _Students["default"],
  'product-updates': _Updates["default"],
  'product-upgrade': _Upgrade["default"],
  'product-webinar-replay': _Webinarreplay["default"]
};
var _default = icons;
exports["default"] = _default;